module.exports = __webpack_public_path__ + "static/img/groundabou10t.c7b14d44.png";